import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Typography } from '@mui/material';
import { deleteUser } from 'aws-amplify/auth';
import { UsersApi } from 'services/users/users.api';

import usePromiseStatus from 'hooks/usePromiseStatus';

import { IModalProps as IProps } from 'interfaces/auth';

import { Button } from 'components/_basic/Button/Button';
import { CloseButton } from 'components/_basic/CloseButton/CloseButton';
import { ModalComponent } from 'components/_basic/ModalComponent/ModalComponent';

import ToastService from 'helpers/ToastService';

import styles from './DeleteAccountModal.module.scss';

export const DeleteAccountModal: FC<IProps> = ({ isModalOpened, onModalClose: handleModalClose }) => {
  const { t } = useTranslation();

  const { track, isPending } = usePromiseStatus();

  const deleteAccountHandler = async () => {
    try {
      await track(UsersApi.delete());
      await track(deleteUser());
    } catch (error) {
      if (error instanceof Error) {
        ToastService.showError(error.message);
      }
    }
  };

  return (
    <ModalComponent open={isModalOpened} onClose={handleModalClose}>
      <Box className={styles.deleteAccountModalWrapper}>
        <Grid container alignItems="center" className={styles.modalTitle}>
          <Grid item xs={11}>
            <Typography variant="h3" component="h3">
              {t('deleteAccountModalTitle')}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <CloseButton onClick={handleModalClose} />
          </Grid>
        </Grid>
        <Box className={styles.contentWrapper}>
          <Typography variant="body2" component="p">
            {t('sureWantToDeleteAccount')}
          </Typography>
          <Typography variant="body2" component="p">
            {t('allDataWillBeLost')}
          </Typography>
        </Box>
        <Box className={styles.buttonWrapper}>
          <Button fullWidth disabled={isPending} variant="outlined" onClick={handleModalClose}>
            {t('cancel')}
          </Button>
          <Button fullWidth isLoading={isPending} variant="contained" color="error" onClick={deleteAccountHandler}>
            {t('deleteAccountModalTitle')}
          </Button>
        </Box>
      </Box>
    </ModalComponent>
  );
};
